import { OTA_PersonName } from "./ota_personname.model";
import { OTA_Telephone } from "./ota_telephone.model";
import { OTA_Email } from "./ota_email.model";
import { OTA_Address } from "./ota_address.model";
import { OTA_CustLoyalty } from "./ota_custloyalty.model";
import { OTA_Document } from "./ota_document.model";

export class OTA_Primary {
    public gender: string = "Unknown";
    public maritalStatus: string = "Unknown";
    public personName = new OTA_PersonName();
    public customerId: number;
    public birthDate?: Date;
    public telephones = new Array<OTA_Telephone>();
    public emails = new Array<OTA_Email>();
    public addresses = new Array<OTA_Address>();
    public custLoyalties = new Array<OTA_CustLoyalty>();
    public documents = new Array<OTA_Document>();
}
